import DirtyInformer, { DispatchProps, OwnProps } from './DirtyInformer';
import { connect } from 'react-redux';
import * as appUI from '../../../modules/uis/app';

const mapDispatchToProps: DispatchProps = {
    setHasDirtyData: appUI.actions.setHasDirtyData
};

export default connect<{}, DispatchProps, OwnProps>(null, mapDispatchToProps)(DirtyInformer);


// WEBPACK FOOTER //
// ./src/components/shared/dirty-data/DirtyInformer.container.tsx